import { render, staticRenderFns } from "./QuotaLimitCard.vue?vue&type=template&id=3d37f33a&scoped=true"
import script from "./QuotaLimitCard.vue?vue&type=script&lang=js"
export * from "./QuotaLimitCard.vue?vue&type=script&lang=js"
import style0 from "./QuotaLimitCard.vue?vue&type=style&index=0&id=3d37f33a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d37f33a",
  null
  
)

export default component.exports